<template>
    <div class="feedbackContainer">
        <div class="feedbackTextContainer"><p class="feedbackText">Were these results helpful?</p></div>
        <div class="feedbackLinksContainer">
            <a @click="togglePositiveFB($event)" class="feedbackLinks"><span class="feedbackBtns thumbsUpOutlineBtn"></span></a>
            <a @click="toggleNegativeFB($event)" class="feedbackLinks"><span class="feedbackBtns thumbsDownOutlineBtn"></span></a>
        </div>    
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "Feedback",
    props: ["data"],
    methods: {
        togglePositiveFB(event) {
            let el = event.target;

            if(!el.classList.contains('disabled')) {
                el.className = 'feedbackBtns thumbsUpFilledBtn';

                let container = this.findAncestor(el, 'feedbackLinksContainer');

                this.disableButtons(container);

                this.$store.dispatch("handlePositiveFeedback", this.data);
            }
        },
        toggleNegativeFB(event) {
            let el = event.target;

            if(!el.classList.contains('disabled')) {
                el.className = 'feedbackBtns thumbsDownFilledBtn';

                let container = this.findAncestor(el, 'feedbackLinksContainer');

                this.disableButtons(container);

                this.$store.dispatch("handleNegativeFeedback", this.data);
            }
        },
        disableButtons(container) {
            let btnList = container.getElementsByClassName('feedbackBtns');
            
            for (var i = 0; i < btnList.length; i++) {
                btnList[i].classList.add('disabled');
            }
        },
        findAncestor(el, cls) {
            while ((el = el.parentNode) && !el.classList.contains(cls));
            return el;
        }
    }
}
</script>

<style scoped>
.feedbackContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  width: 300px;
  padding-top: 10px;
  margin-left: auto;
}

.feedbackTextContainer {
  padding-right: 15px;
}

.feedbackText {
  font-size: 13px;
  font-weight: 500;
}

.feedbackLinksContainer {
  margin-top: 3px;
}

.feedbackLinksContainer > a:first-of-type {
  margin-right: 15px;
}

.feedbackLinks {
  display: inline-block;
  width: 30px;
}

.feedbackBtns {
  display: block;
  width: 30px;
  height: 34px;
  background-size: 30px;
  background-repeat: no-repeat;
  cursor: pointer;
}

.disabled {
  cursor: default;
}

.thumbsUpOutlineBtn {
  background-image: url(../assets/images/thumbs-up-outline.png);
}

.thumbsUpFilledBtn {
  background-image: url(../assets/images/thumbs-up-filled.png);
}

.thumbsDownOutlineBtn {
  background-image: url(../assets/images/thumbs-down-outline.png);
}

.thumbsDownFilledBtn {
  background-image: url(../assets/images/thumbs-down-filled.png);
}
</style>
